// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__8g4x5","noPadding":"Content_noPadding__55FCs"};